import React, { useContext } from 'react';
import { useLocation, useSearchParams } from 'react-router';
import { LayoutContext } from './LayoutContextProvider';
import { LayoutContextContent } from './LayoutContextProvider.types';

export const useGetLayoutContextValues = (): LayoutContextContent => {
  const isRebrandedQuery = useGetRebrandFromSearchParams();

  return React.useMemo(
    () => ({
      isRebrandedQuery,
    }),
    [isRebrandedQuery],
  );
};

export const useGetRebrandFromSearchParams = (): boolean => {
  const [searchParams] = useSearchParams();
  const beta = searchParams.get('beta');
  return beta === '1';
};

export const useGetPolicyNumberFromLocation = (): string => {
  const location = useLocation();
  const policyNumber = location.pathname.split('/').pop();
  return policyNumber ?? '';
};

export const useLayoutContext = (): LayoutContextContent =>
  useContext(LayoutContext);
